import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { Apiconfig } from '../../core/helpers/apiConfig';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-blog-detail',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './blog-detail.component.html',
  styleUrl: './blog-detail.component.scss'
})
export class BlogDetailComponent implements OnInit {
  pageDescription: string = '';
  heading: string = '';
  slug: string = '';
  recentBlogs: any[] = [];
  pageImage: String = '';
  apiUrl: string = environment.apiUrl;
  current: any;
 safePageDescription!: SafeHtml;
  constructor(
    private metaService: Meta,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: Object

  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Fertility & IVF Blogs | Latest Insights from NCARE IVF Centre in Kannur');
    this.metaService.updateTag({
      name: 'description',
      content:
        'Stay informed with expert-written blogs from NCARE IVFCentre in  Kannur. Explore topics on fertility, IVF, pregnancy care, and reproductive health for reliable, up-to-date guidance.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content:
        'Fertility Blogs, IVF Blog Kannur, Reproductive Health Articles, Pregnancy Care Tips, NCARE IVF Updates'
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Fertility & IVF Blogs | Latest Insights from NCARE IVF Centre in Kannur'
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Stay informed with expert-written blogs from NCARE IVFCentre in  Kannur. Explore topics on fertility, IVF, pregnancy care, and reproductive health for reliable, up-to-date guidance.'
    });

    this.activatedRoute.params.subscribe(params => {
      this.pageImage = '';
      this.pageDescription = '';
      this.slug = params['slug'];
      this.getPageData();
    });
  }

  getPageData() {
  // Fetch the main blog data
  this.apiService
    .commonApi(Apiconfig.Getpage.method, Apiconfig.Getpage.url, { slug: this.slug })
    .subscribe(
      (result: any) => {
        if (result && result.status && result.data) {
          const blog = result.data;
          this.pageDescription = blog.description || '';
          this.safePageDescription = this.sanitizer.bypassSecurityTrustHtml(this.pageDescription);
          console.log(this.pageDescription);

          this.heading = blog.name || '';
          this.current = blog._id || false;
          if(blog.image){

            this.pageImage = this.apiUrl + '/' + blog.image || '';
          }

          // ✅ Dynamically set SEO meta if available
          if (blog.seo) {
            // Page title
            if (blog.seo.title) {
              this.titleService.setTitle(blog.seo.title);
              this.metaService.updateTag({ property: 'og:title', content: blog.seo.title });
            }

            // Meta description
            if (blog.seo.description) {
              this.metaService.updateTag({ name: 'description', content: blog.seo.description });
              this.metaService.updateTag({ property: 'og:description', content: blog.seo.description });
            }

            // Meta keywords (array or string)
            if (blog.seo.meta_keywords && Array.isArray(blog.seo.meta_keywords)) {
              this.metaService.updateTag({
                name: 'keywords',
                content: blog.seo.meta_keywords.join(', ')
              });
            } else if (blog.seo.keyword) {
              this.metaService.updateTag({
                name: 'keywords',
                content: blog.seo.keyword
              });
            }
          }

          this.getRecentBlogs();
        }
      },
      error => {
        console.log(error);
      }
    );
}

  getRecentBlogs() {
    // Fetch all blogs, then filter out the current one
    this.apiService.commonApi(Apiconfig.listPage.method, Apiconfig.listPage.url, {}).subscribe(
      (result: any) => {

        if (result) {
          this.recentBlogs = result.filter((blog: any) => blog._id !== this.current);
          console.log(this.recentBlogs);
          
        }
      },
      error => {
        console.log(error);
      }
    );
  }


  sanitizeContent(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

extractFirstHeading(content: string): SafeHtml {
  if (!content) return '';

  // Find the first heading tag (h1–h6)
  const match = content.match(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/i);

  if (!match) return '';

  // Extract only the inner text (group 1)
  const innerText = match[1].replace(/<[^>]*>/g, ''); // remove nested tags if any

  // Wrap in clean <h5>
  const cleanHeading = `<h5>${innerText}</h5>`;

  return this.sanitizer.bypassSecurityTrustHtml(cleanHeading);
}

trimDescriptionKeepImage(
  html: string,
  length: number = 100,
  isMainBlog: boolean = true
): string {
  if (!html) return '';

  let imageTag = '';
  let textContent = '';

  // Extract first <img> if exists
  const imgMatch = html.match(/<img[^>]+src="([^">]+)"[^>]*>/i);
  if (imgMatch) {
    const imgSrc = imgMatch[1];
    const width = isMainBlog ? 856 : 416;
    const height = isMainBlog ? 570 : 277;

    imageTag = `<img src="${imgSrc}" width="${width}" height="${height}" 
                  style="object-fit:cover;display:block;margin-bottom:10px;">`;
  }

  // Extract plain text (no HTML tags)
  if (isPlatformBrowser(this.platformId)) {
    // Browser: safe to use DOM parsing
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    textContent = tempDiv.textContent || tempDiv.innerText || '';
  } else {
    // SSR: regex strip tags
    textContent = html.replace(/<[^>]*>/g, '');
  }

  // If main blog → return full text
  if (isMainBlog) {
    return imageTag + `<p>${textContent}</p>`;
  }

  // Else → trim for recent blog
  const trimmedText =
    textContent.length > length
      ? textContent.substring(0, length) + '...'
      : textContent;

  return imageTag + `<p>${trimmedText}</p>`;
}


}
